module.exports = __webpack_public_path__ + "static/media/issue.747f5d6c.svg";